<template>
  <div id="calculationRepayment">
    <div class="headerStatus">
      <h3>还款试算</h3>

    </div>
    <div class="amountStatus">
      <span class="styleMoney">¥</span>
      <input
        class="styleInput"
        @blur="blurChange"
        v-model="amount"
        type="number"
        ref="myInput"
        :placeholder="waitprincipal"
        :autofocus="autofocus"
      />
      <img
        @click="btnImg"
        class="btnImg"
        src="@/assets/images/jilu.png"
        alt=""
      />
    </div>
    <p>应还本金</p>
    <ul>
      <li class="infoList">
        <span class="infoListLeft">还款日期</span>
        <span class="infoListRight">{{
          this.otherPages.addOkCalculationObj.repay_date || ''
        }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">应还本金</span>
        <span class="infoListRight">¥{{
            this.otherPages.addOkCalculationObj.repay_princ_now || ''
          }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">应还利息</span>
        <span class="infoListRight">¥{{
            this.otherPages.addOkCalculationObj.repay_inter_now || ''
          }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">应还金额</span>
        <span class="infoListRight">¥{{ this.otherPages.addOkCalculationObj.repay_amt_now || '' }}</span>
      </li>
      <li class="infoList">
        <span class="infoListLeft">剩余本金</span>
        <span class="infoListRight">¥{{ this.otherPages.addOkCalculationObj.rest_amt || '' }}</span>
      </li>
    </ul>
    <Button
      :text="draw"
      :type="danger"
      class="nextStep"
      :click="goToNextPage"
      :disabled="canGoNext"
    />
  </div>
</template>
<script>
import Button from '@/components/Button.vue';
import { mapState, mapMutations } from 'vuex';
import { Toast, Dialog } from 'vant';

export default {
  name: 'calculationRepayment',
  data() {
    return {
      danger: 'danger',
      draw: '确认还款',
      disabled: true,
      autofocus: false,
      waitprincipal: '',
    };
  },
  components: {
    Button,
  },
  mounted() {
    this.updateForm({
      drawId: localStorage.getItem('drawId'),
      orderId: localStorage.getItem('orderId'),
    });
    this.$api.OtherPage.getRestAmt({
      orderId: this.otherPages.orderId,
      drawId: this.otherPages.drawId,
    }).then((res) => {
      if (res.success) {
        const { data } = res;
        this.updateForm({ amount: data.rest_amt });
        this.waitprincipal = data.rest_amt;
        this.blurChange();
      } else {
        Toast(res.returnMessage);
      }
    });
  },
  computed: {
    ...mapState({
      otherPages(val) {
        return val.otherPages;
      },
    }),
    amount: {
      get() {
        return this.otherPages.amount;
      },
      set(v) {
        this.otherPages.amount = v;
      },
    },
    canGoNext() {
      let multiCheck = true;
      if (this.otherPages.isBtn) {
        multiCheck = false;
      }
      return multiCheck;
    },
  },
  methods: {
    ...mapMutations('otherPages', ['updateForm']),
    goToNextPage() {
      Dialog.confirm({
        title: '重要提示',
        message: '您正在进行提前还款操作，提前还款不会抵扣当期本金利息，本期还款日（15日）您仍需按最新的还款金额存入还款金等待划扣。是否继续？',
      }).then(() => {
        this.$store.dispatch('otherPages/prepayment');
      })
        .catch(() => {
        });
    },
    blurChange() {
      const { amount } = this.$store.state.otherPages;
      const VALIATEREGTWO = /^([1-9]\d*|0)(\.\d{0,2})?$/;
      const VALIATEREGONE = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (amount === '') {
        Toast('待还金额金额不能为空');
        return;
      }
      if (!amount) {
        Toast('待还金额不能为0');
        return;
      }
      if (!VALIATEREGONE.test(amount)) {
        Toast('待还金额只支持数字输入');
        return;
      }

      if (!VALIATEREGTWO.test(amount)) {
        Toast('待还金额只支持二位小数');
        return;
      }

      if (Number(amount) > Number(this.waitprincipal)) {
        Toast('待还金额不能大于应还本金');
        return;
      }
      this.$store.dispatch('otherPages/addOkCalculation');
    },
    btnImg() {
      this.$refs.myInput.focus();
      this.$store.commit('otherPages/updateForm');
    },
  },
};
</script>
<style scoped>
#calculationRepayment {
  width: 100%;
  height: 100%;
  background: #fff;
}
.infoList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  height: 50px;
  margin: 0 auto;
}
.infoListLeft {
  color: #7d828e;
  font-size: 14px;
}
.infoListRight {
  color: #000;
  font-size: 14px;
}
.nextStep {
  margin-top: 30px;
}
.styleInput {
  width: 120px;
  height: 27px;
  font-size: 22px;
  font-family: PingFangSC-Medium;
  color: #f65846;
  font-weight: bold;
  border: 0;
  margin-right: 10px;
}
.styleMoney {
  font-size: 22px;
  font-family: PingFangSC-Medium;
  color: #f65846;
  margin-right: 3px;
}
.amountStatus {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
}
.btnImg {
  width: 17px;
  height: 17px;
}
.headerStatus {
  position: relative;
}
.headerStatus p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.headerStatus h3 {
  margin: 0;
  padding-top: 16px;
  font-size: 18px;
}
input::-webkit-input-placeholder {
  color: rgb(202, 198, 198);
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgb(202, 198, 198);
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgb(202, 198, 198);
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgb(202, 198, 198);
}
</style>
